import { useState } from 'react';
import RecommendedArtists from '../components/cards/aside/recommended-artists';
import SuggestedChannels from '../components/cards/aside/suggested-channels';
import Container from '../components/containers/container';
import SubscriptionsContainer from '../components/containers/subscriptions.container';
import Header from '../components/header/default.header';
import HorizontalBar from '../components/horizontalBar';
import { VStack } from '../components/layouts/stack.layout';
import MainLayout from '../components/layouts/v2/main.layout';
import AlternativeNavigation from '../components/navigation/alternative.navigation';
import HTab from '../components/navigation/tabs/htab';
import { SUBSCRIPTIONS_TAB_OPTIONS } from '../components/navigation/tabs/tab-options';
import Search from '../components/overlay/search';

export default function Releases() {
  const [currentTab, setCurrentTab] = useState(
    SUBSCRIPTIONS_TAB_OPTIONS.TRACKING
  );

  const CONTENT_COMPONENT_MAP = {
    [SUBSCRIPTIONS_TAB_OPTIONS.TRACKING]: () => (
      <SubscriptionsContainer query={['TRACKING']} trigger={() => {}} />
    ),
    [SUBSCRIPTIONS_TAB_OPTIONS.LIVE]: () => (
      <SubscriptionsContainer query={['LIVE']} trigger={() => {}} />
    ),
    [SUBSCRIPTIONS_TAB_OPTIONS.RECOMMENDED]: () => (
      <SubscriptionsContainer query={['RECOMMENDED']} trigger={() => {}} />
    ),
  };

  return (
    <MainLayout title="Subscriptions">
      <MainLayout.Header>
        <Header />
      </MainLayout.Header>
      <MainLayout.Content>
        <MainLayout.Navigation>
          <AlternativeNavigation />
        </MainLayout.Navigation>
        <MainLayout.Main>
          <HTab
            current={currentTab}
            set={setCurrentTab}
            tabOptions={SUBSCRIPTIONS_TAB_OPTIONS}
            tabContent={CONTENT_COMPONENT_MAP}
            tabControlClassName="mobile:py-4 tablet-lg:pb-5 mobile:px-2 tablet-lg:px-[40px] border-b border-dark-gray"
          />
        </MainLayout.Main>
      </MainLayout.Content>
      <MainLayout.Aside>
        <VStack>
          <Container extensions="w-full pb-2 mobile:px-2 tablet-lg:px-[40px]">
            <Search />
          </Container>
          <RecommendedArtists />
          <HorizontalBar />
          <SuggestedChannels />
          {/* <HorizontalBar />
          <LatestReleases /> */}
        </VStack>
      </MainLayout.Aside>
    </MainLayout>
  );
}
